"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    NATIVE_SPEAKER: 'Native Speaker',
    FLUENT: 'Fluent',
    ADVANCED: 'Advanced',
    INTERMEDIATE: 'Intermediate',
    BASIC: 'Basic',
};
//# sourceMappingURL=languageProficiency.js.map